import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const userAuthentication = createAsyncThunk("userAuthentication", async () => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.get(`${API_KEY}/api/user/authenticate-dashboard`, {
      headers: { Authorization: `Barear ${token}`},
      "Content-Type": "application/json",
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  userAuthenticationData: null,
  isError: false,
  errorMessage: "",
};
const userAuthenticationSlice = createSlice({
  name: "userAuthentication",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userAuthentication.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userAuthentication.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userAuthenticationData = action.payload;
    });
    builder.addCase(userAuthentication.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default userAuthenticationSlice.reducer;